import { useEffect, useState } from "react";
import TreeView from '@mui/lab/TreeView';
import TreeItem from '@mui/lab/TreeItem';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

import { Button, Paper, Typography, Icon, useTheme, LinearProgress } from "@mui/material";
import { Box } from "@mui/system";
import { useNavigate } from "react-router-dom";

import { LayoutBaseDePagina } from "../../shared/layouts";
import { IListagemTipo, RenderTree, TipoService } from "../../shared/services/api/tipo/TipoService";
import { AutoCompleteDeSetor } from "../../shared/components/autocompletes/AutoCompleteDeSetor";
import { Environment } from "../../shared/environment";
import { AlertSnackBar } from "../../shared/components/alert/AlertSnackBar";
import { DialogConfirm } from "../../shared/components/dialog/DialogConfirm";

export const ListagemDeTipo: React.FC = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  const [rows, setRows] = useState<IListagemTipo[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const [alert, setAlert] = useState<{ tipoAlert: string, mensagem: string } | undefined>(undefined);
  const [duracaoAlert, setDuracaoAlert] = useState<number>(Environment.DURACAO_ALERT + 500);

  const [selectedIdTipo, setSelectedIdTipo] = useState(0);
  const [selectedNomeTipo, setSelectedNomeTipo] = useState('nenhum');
  const [selectedNivel, setSelectedNivel] = useState(0);
  const [selected, setSelected] = useState<string[]>([]);

  const [idSetor, setIdSetor] = useState<number | undefined>(undefined);
  useEffect(() => { setIdSetor(Number(localStorage.getItem("idSetor"))) }, [])

  const handleSelect = (event: React.SyntheticEvent, nodeIds: string[]) => {
    setSelected(nodeIds);
  };

  const handleClick = (idTipo: number, nomeTipo: string, nivel: number) => {
    setSelectedIdTipo(idTipo);
    setSelectedNomeTipo(nomeTipo);
    setSelectedNivel(nivel);
  }

  const handleLimparSelecao = () => {
    setSelectedIdTipo(0);
    setSelectedNomeTipo('nenhum');
    setSelectedNivel(0);
    setSelected((oldSelected) =>
      oldSelected.length === 0 ? ['1', '2', '3', '4', '5', '6', '7', '8', '9'] : [],
    );
  }

  const handleNovo = () => {
    if (idSetor !== undefined && idSetor !== null && idSetor !== 0) {
      navigate(`/tipo/novo/${selectedIdTipo}/${selectedNomeTipo}/${selectedNivel}/${idSetor}`);
    } else {
      setAlert({ tipoAlert: "erro", mensagem: "Selecione um setor" });
      setTimeout(() => {
        setAlert(undefined);
      }, duracaoAlert);
    }
  }

  useEffect(() => {

    listagemTipos();

  }, [idSetor]);

  const listagemTipos = () => {
    if (idSetor !== undefined && idSetor !== null && idSetor !== 0) {
      setRows([]);
      setIsLoading(true);
      TipoService.getByIdSetor(idSetor, undefined, true).then((result) => {
        setIsLoading(false);

        if (result instanceof Error) {//verificar se deu erro
          setAlert({ tipoAlert: "erro", mensagem: result.message });
          setTimeout(() => {
            setAlert(undefined);
          }, duracaoAlert);
        }
        else {
          setRows(result);

        }
      });
    } else {
      setRows([]);
    }
  }

  const renderTree = (nodes: RenderTree) => (
    <TreeItem key={nodes.idTipo} nodeId={(nodes.idTipo).toString()} label={nodes.nomeTipo} onClick={() => handleClick(nodes.idTipo, nodes.nomeTipo, nodes.nivel)}>
      {Array.isArray(nodes.tipos)
        ? nodes.tipos.map((node) => renderTree(node))
        : null}
    </TreeItem>
  );

  const [abrir, setAbrir] = useState(false);
  const handleCancel = () => {
    setAbrir(false);
  }
  const handleDelete = () => {
    setAbrir(false);
    setIsLoading(true);
    TipoService.deleteById(selectedIdTipo).then((result) => {
      setIsLoading(false);

      if (result instanceof Error) {//verificar se deu erro
        setAlert({ tipoAlert: "erro", mensagem: result.message });
        setTimeout(() => {
          setAlert(undefined);
        }, duracaoAlert);
      } else {
        listagemTipos();
        handleLimparSelecao();
      }
    })
  }

  return (
    <LayoutBaseDePagina
      titulo="Listagem de tipos"
      barraDeFerramentas={null}
    >
      {alert !== undefined && (
        <>
          {alert.tipoAlert === "sucesso" && (
            <AlertSnackBar gravidade="success" mensagem={alert.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
          )}
          {alert.tipoAlert === "erro" && (
            <AlertSnackBar gravidade="error" mensagem={alert.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
          )}
          {alert.tipoAlert === "aviso" && (
            <AlertSnackBar gravidade="warning" mensagem={alert.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
          )}
        </>
      )}

      <DialogConfirm
        AoConfirmar={handleDelete}
        titulo={"Dejesa realmente excluir o tipo?"}
        texto={"Ao confirmar, não será possível recupera-lo."}
        abrir={abrir}
        AoCancelar={handleCancel}
      />

      <Box
        component={Paper}
        height={theme.spacing(5)}
        marginX={1}
        padding={1}
        paddingX={2}
        display="flex"
        justifyContent="center"
        gap={1}
        marginBottom={theme.spacing(1)}
      >
        <AutoCompleteDeSetor selectedIdSetor={selectedIdSetor => setIdSetor(selectedIdSetor)} />
      </Box>

      <Box
        component={Paper}
        height={theme.spacing(5)}
        marginX={1}
        padding={1}
        paddingX={2}
        display="flex"
        gap={1}
        justifyContent="center"
      >

        {selected.length !== 0 && (
          <Typography variant="button" noWrap>
            <Button
              color="error"
              disableElevation
              variant="contained"
              endIcon={<Icon>delete</Icon>}
              onClick={() => setAbrir(true)}>
              Excluir
            </Button>
          </Typography>
        )}

        {selected.length !== 0 && (
          <Typography variant="button" noWrap>
            <Button
              color="warning"
              disableElevation
              variant="contained"
              endIcon={<Icon>clear</Icon>}
              onClick={handleLimparSelecao}
            >
              Desselecionar
            </Button>
          </Typography>
        )}

        {selected.length !== 0 && (
          <Typography variant="button" noWrap>
            <Button
              color="primary"
              disableElevation
              variant="contained"
              endIcon={<Icon>edit</Icon>}
              onClick={() => navigate(`/tipo/editar/${selectedIdTipo}/nulll/nulll/nulll`)}
            >
              Editar
            </Button>
          </Typography>
        )}

        <Typography variant="button" noWrap>
          <Button
            color="success"
            disableElevation
            variant="contained"
            endIcon={<Icon>add</Icon>}
            onClick={handleNovo}
          >
            Novo
          </Button>
        </Typography>

      </Box>

      <Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined" padding={2}>
        {isLoading && (
          <LinearProgress variant="indeterminate" />
        )}
        <TreeView
          defaultCollapseIcon={<ExpandMoreIcon />}
          defaultExpandIcon={<ChevronRightIcon />}
          selected={selected}
          onNodeSelect={handleSelect}
          sx={{ width: 500, minHeight: 500, flexGrow: 1 }}
        >

          {rows.map(tipo => renderTree(tipo))}

        </TreeView>
      </Box>
    </LayoutBaseDePagina>
  )
}